export enum Currency {
  BTC = 'BTC',
  LTC = 'LTC',
  EGLD = 'EGLD',
  ETH = 'ETH',
  BNB = 'BNB',
  USDT_ETH = 'USDT_ETH',
  USDT_BNB = 'USDT_BNB',
  TRX = 'TRX',
  USDT_TRX = 'USDT_TRX',
  WBTC_ETH = 'WBTC_ETH',
  WBTC_BNB = 'WBTC_BNB',
  USDC_ETH = 'USDC_ETH',
  USDC_BNB = 'USDC_BNB',
  USD1_ETH = 'USD1_ETH',
  USD1_BNB = 'USD1_BNB',
  DOGE = 'DOGE',
  POL = 'POL',
  USDT_POL = 'USDT_POL',
  USDC_POL = 'USDC_POL',
  ARB = 'ARB',
  ETH_ARB = 'ETH_ARB',
  USDT_ARB = 'USDT_ARB',
  USDC_ARB = 'USDC_ARB',
  ETH_BASE = 'ETH_BASE',
  USDT_BASE = 'USDT_BASE',
  USDC_BASE = 'USDC_BASE',
  CWEB = 'CWEB', // L2 token
  WCWEB_ETH = 'WCWEB_ETH', // wrapped cweb - ERC20
  SOL = 'SOL',
  USDT_SOL = 'USDT_SOL',
  USDC_SOL = 'USDC_SOL',
}

const CURRENCY_VALUES: ReadonlySet<string> = new Set(Object.values(Currency));

export function isCurrency(value: string): value is Currency {
  return CURRENCY_VALUES.has(value);
}

export function parseCurrencyList(value: string | undefined): Currency[] {
  return (value ?? '')
    .split(',')
    .map((token) => token.trim())
    .filter(isCurrency);
}
